// Region-specific fulfilment notices (content/fulfilment-notices.json). A notice
// applies to a product page selection when the visitor's region is listed, the
// selection includes one of its itemTypes and now is inside [from, until).
// Backend importantMessages are global across regions, which is why a notice
// that only concerns one fulfilment store lives here instead.
import config from '../content/fulfilment-notices.json'
import { offerItemType } from './saleCampaign'

const toMs = (v) => (v === null || v === undefined || v === '' ? NaN : Date.parse(v))

export function getFulfilmentNotice(region, items, nowMs = Date.now(), notices = config.notices) {
  if (!region || !Array.isArray(items) || !items.length || !Array.isArray(notices)) return null
  const types = items.map(offerItemType).filter(Boolean)
  return notices.find((n) => {
    if (!n || !Array.isArray(n.regions) || !n.regions.includes(region)) return false
    if (!Array.isArray(n.itemTypes) || !types.some((t) => n.itemTypes.includes(t))) return false
    const from = toMs(n.from)
    const until = toMs(n.until)
    if (Number.isFinite(from) && nowMs < from) return false
    if (Number.isFinite(until) && nowMs >= until) return false
    return true
  }) || null
}
